<template>
  <CChannelWatcher />
</template>
<script>
import CChannelWatcher from './CChannelWatcher.vue'

export default {
  components: { CChannelWatcher },
  mounted() {
    this.$store.dispatch('channel/staff/getStaff')
  },
  beforeUnmount() {
    this.$store.dispatch('channel/clearChannelScope')
  }
}
</script>
